// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as $$Promise from "@ryyppy/rescript-promise/src/Promise.bs.mjs";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Form$MakerDs from "maker-ds/src/Form.bs.mjs";
import * as Alert$MakerDs from "maker-ds/src/Alert.bs.mjs";
import * as Date$FeedSync from "./Date.bs.mjs";
import * as Query$MakerDs from "maker-ds/src/Query.bs.mjs";
import * as Button$MakerDs from "maker-ds/src/Button.bs.mjs";
import * as Search$MakerDs from "maker-ds/src/Search.bs.mjs";
import * as Select$MakerDs from "maker-ds/src/Select.bs.mjs";
import * as Layout$FeedSync from "./Layout.bs.mjs";
import * as Location$FeedSync from "./Location.bs.mjs";
import * as ClientAPI$FeedSync from "./ClientAPI.bs.mjs";
import * as ProductTable$FeedSync from "./ProductTable.bs.mjs";

var timeOfLoadingApp = Date.now();

function DataPage$ResultsTable(Props) {
  var searchOpt = Props.search;
  var timestamp = Props.timestamp;
  var currencyOpt = Props.currency;
  var search = searchOpt !== undefined ? searchOpt : "";
  var currency = currencyOpt !== undefined ? currencyOpt : "";
  var staticCacheOnly = timestamp !== timeOfLoadingApp;
  var match = ClientAPI$FeedSync.useRawData(search, timestamp, currency, staticCacheOnly);
  var error = match.error;
  var setSize = match.setSize;
  var size = match.size;
  var data = match.data;
  console.log(error);
  if (error !== undefined) {
    return Belt_Option.getWithDefault(error.RE_EXN_ID === $$Promise.JsError || error.RE_EXN_ID === Js_exn.$$Error ? error._1.message : error.message, "An unknown error occurred");
  }
  if (data === undefined) {
    return "Loading...";
  }
  var products = Belt_Array.concatMany(Belt_Array.map(data, (function (page) {
              return page.products;
            })));
  var next = Belt_Option.flatMap(Belt_Array.get(data, data.length - 1 | 0), (function (page) {
          return page.next;
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(ProductTable$FeedSync.make, {
                  products: products
                }), next !== undefined ? React.createElement(Button$MakerDs.make, {
                    onClick: (function (param) {
                        Curry._1(setSize, size + 1 | 0);
                      }),
                    outline: true,
                    text: "Load more"
                  }) : null);
}

var ResultsTable = {
  make: DataPage$ResultsTable
};

function DataPage$Show(Props) {
  var snapshots = Props.snapshots;
  var timestamp = Props.timestamp;
  var currency = Props.currency;
  var search = Props.search;
  var search$1 = search !== undefined ? search : "";
  var onSearch = function (newSearch) {
    Location$FeedSync.goTo(true, undefined, Caml_option.some(Js_dict.fromArray([[
                    "search",
                    newSearch
                  ]])), undefined, Belt_Array.keepMap([
              "data",
              Belt_Option.map(timestamp, (function (prim) {
                      return prim.toString();
                    })),
              currency
            ], (function (a) {
                return a;
              })));
  };
  var snapshotsWithData = Belt_Array.keep(snapshots, (function (t) {
          if (t.downloadedAndStaticCached) {
            return t.startTime > 1733574763653.0;
          } else {
            return false;
          }
        }));
  var latestSuccessfulSnapshot = Belt_Array.getBy(snapshotsWithData, (function (tracker) {
          return Belt_Option.mapWithDefault(tracker.result, false, Belt_Result.isOk);
        }));
  if (latestSuccessfulSnapshot === undefined) {
    return React.createElement(Alert$MakerDs.make, {
                kind: /* Info */3,
                background: true,
                border: true,
                children: null
              }, React.createElement("div", {
                    className: CSS$MakerDs.prefix("mb-2")
                  }, "Start by configuring your feed on the Settings page."), React.createElement(Button$MakerDs.make, {
                    onClick: (function (param) {
                        Location$FeedSync.goTo(undefined, undefined, undefined, undefined, ["settings"]);
                      }),
                    outline: true,
                    text: "Go to Settings"
                  }));
  }
  var timestamp$1 = Belt_Option.getWithDefault(timestamp, latestSuccessfulSnapshot.startTime);
  var dataSourceOptions = Belt_Array.concat([{
          title: "Download latest",
          value: String(timeOfLoadingApp),
          group: undefined
        }], Belt_Array.map(snapshotsWithData, (function (tracker) {
              var rollbackTime = tracker.rollbackTime;
              return {
                      title: rollbackTime !== undefined ? "" + Date$FeedSync.formatDistanceToNow(new Date(tracker.startTime)) + " \n                  (Rollback)\n                  " + (
                          Caml_obj.equal(tracker._isLive, true) ? " (Current)" : ""
                        ) + "" : "" + Date$FeedSync.formatDistanceToNow(new Date(tracker.startTime)) + " " + (
                          Caml_obj.equal(tracker._isLive, true) ? " (Current)" : ""
                        ) + "",
                      value: String(tracker.startTime),
                      group: undefined
                    };
            })));
  var currencyOptions = Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.getBy(snapshots, (function (snapshot) {
                  return snapshot.startTime === timestamp$1;
                })), (function (snapshot) {
              return Belt_Array.map(snapshot.settings.currencies, (function (currency) {
                            var currencyCode = currency[0];
                            var tmp = currencyCode === "" ? "USD" : currencyCode;
                            return {
                                    title: tmp,
                                    value: currencyCode,
                                    group: undefined
                                  };
                          }));
            })), []);
  var currency$1 = currency !== undefined ? currency : Belt_Option.map(Belt_Option.flatMap(Belt_Array.getBy(snapshots, (function (snapshot) {
                    return snapshot.startTime === timestamp$1;
                  })), (function (snapshot) {
                return Belt_Array.get(snapshot.settings.currencies, 0);
              })), (function (param) {
            return param[0];
          }));
  var onChangeDataSource = function (value) {
    Location$FeedSync.goTo(undefined, undefined, undefined, undefined, [
          "data",
          value,
          Belt_Option.getWithDefault(currency$1, "")
        ]);
  };
  var onChangeCurrency = function (value) {
    Location$FeedSync.goTo(undefined, undefined, undefined, undefined, [
          "data",
          timestamp$1.toFixed(),
          value
        ]);
  };
  var tmp = {
    options: currencyOptions,
    onChange: onChangeCurrency,
    width: 60
  };
  if (currency$1 !== undefined) {
    tmp.value = Caml_option.valFromOption(currency$1);
  }
  var tmp$1 = {
    search: search$1,
    timestamp: timestamp$1
  };
  if (currency$1 !== undefined) {
    tmp$1.currency = Caml_option.valFromOption(currency$1);
  }
  return React.createElement(Form$MakerDs.make, {
              title: "Data Explorer",
              description: "Explore and validate feed data.",
              children: null,
              footer: false
            }, React.createElement("div", {
                  className: CSS$MakerDs.prefix("flex gap-2 max-w-3xl")
                }, React.createElement(Select$MakerDs.make, {
                      value: timestamp$1.toString(),
                      options: dataSourceOptions,
                      onChange: onChangeDataSource,
                      width: 60
                    }), React.createElement(Select$MakerDs.make, tmp), React.createElement(Search$MakerDs.make, {
                      value: search$1,
                      onSearch: onSearch,
                      placeholder: "Search raw data"
                    })), React.createElement(DataPage$ResultsTable, tmp$1));
}

var Show = {
  make: DataPage$Show
};

function DataPage(Props) {
  var timestamp = Props.timestamp;
  var currency = Props.currency;
  var search = Props.search;
  return React.createElement(Query$MakerDs.make, {
              hook: (function (param) {
                  return ClientAPI$FeedSync.useSettings(undefined);
                }),
              render: (function (latestSettings, param) {
                  return React.createElement(Query$MakerDs.make, {
                              hook: (function (param) {
                                  return ClientAPI$FeedSync.useSnapshotHistory(undefined);
                                }),
                              render: (function (snapshots, param) {
                                  var rollbackTime = Belt_Option.flatMap(Belt_Array.getBy(snapshots, (function (snapshot) {
                                              return Caml_obj.equal(snapshot.startTime, timestamp);
                                            })), (function (snapshot) {
                                          return snapshot.rollbackTime;
                                        }));
                                  var shownTimestamp = rollbackTime !== undefined ? rollbackTime : timestamp;
                                  return React.createElement(Layout$FeedSync.make, {
                                              activeNavItem: /* DataItem */2,
                                              children: React.createElement(DataPage$Show, {
                                                    snapshots: snapshots,
                                                    latestSettings: latestSettings,
                                                    timestamp: shownTimestamp,
                                                    currency: currency,
                                                    search: search
                                                  })
                                            });
                                })
                            });
                })
            });
}

var make = DataPage;

export {
  timeOfLoadingApp ,
  ResultsTable ,
  Show ,
  make ,
}
/* timeOfLoadingApp Not a pure module */
